var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTau = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 800,
  height: 800,
  viewBox: "0 0 800 800"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.85948 0 0 .85948 -31.113 -30.082)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M501.6 35c-257 0-465.4 208.4-465.4 465.4s208.4 465.4 465.4 465.4S967 757.4 967 500.4 758.6 35 501.6 35m0 903.7c-242.1 0-438.3-196.2-438.3-438.3S259.6 62.1 501.6 62.1s438.3 196.2 438.3 438.3-196.2 438.3-438.3 438.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M309.1 254.7c0-64.1 31.2-120.8 79.2-156C213.6 148.3 85.7 309 85.7 499.6c0 225.9 179.7 409.7 403.9 416.6V447.6c-100.8-6.7-180.5-90.5-180.5-192.9M616.6 98.6c48 35.2 79.2 92 79.2 156 0 102.4-79.7 186.3-180.5 192.9V916c224.2-6.8 403.9-190.7 403.9-416.6 0-190.4-127.9-351.1-302.6-400.8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 502.4,
  cy: 254.7,
  r: 171.9
}))));
export default SvgTau;